import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 560px;
	max-width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1.2rem;
	box-sizing: border-box;

	> div {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		gap: 0.5rem;
	}

	@media (max-width: 600px) {
		width: 100%;
	}
`;

export const sectionDivider = styled.hr`
	width: 100%;
	border: 0;
	height: 1px;
	background: ${color.interface.lightGray2};
	margin: 0.5rem 0;
`;

export const sectionTitle = styled.h4`
	width: 100%;
	font-size: 1.5rem;
	font-weight: 700;
	color: ${color.interface.blackMofiq};
	margin: 0.3rem 0;
	text-align: left;
`;

export const threeColumns = styled.div`
	width: 100%;
	display: grid !important;
	grid-template-columns: repeat(3, 1fr);
	gap: 1rem;
	align-items: flex-start !important;
`;

export const twoInputs = styled.div`
	width: 100%;
	display: grid !important;
	grid-template-columns: 1fr 1fr;
	gap: 1rem;
`;

export const fullWidth = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
`;

export const errorText = styled.p`
	width: 100%;
	color: ${color.system.error};
	font-size: 1.2rem;
	font-weight: 600;
	text-align: left;
	margin-top: -0.5rem;
`;

export const containerBtns = styled.div`
	width: 100%;
	margin-top: 1rem;
	display: flex;
	align-items: center;
	justify-content: flex-end !important;
	gap: 1rem;

	> button {
		all: unset;

		text-align: center;
		border-radius: 5px;
		padding: 1rem 2rem;
		color: ${color.interface.white};
		font-size: 1.3rem;
		cursor: pointer;

		&:disabled {
			opacity: 0.6;
			cursor: not-allowed;
		}
	}
`;

export const save = styled.button`
	background-color: ${color.system.success} !important;
`;

export const cancel = styled.button`
	background-color: ${color.system.error} !important;
`;
